import { render, staticRenderFns } from "./bind-space-rg.vue?vue&type=template&id=f6ca52f4&"
import script from "./bind-space-rg.vue?vue&type=script&lang=ts&"
export * from "./bind-space-rg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports